import { Box, Typography } from "@mui/material";
import { CustomerOrderSummary } from "src/api/generated/erp/sales/customerOrder/service/customerOrderSummary.ts";
import { CustomerOfferSummary } from "src/api/generated/erp/sales/customerOrderOffer/service/customerOfferSummary.ts";
import { useCustomerOrderOrOfferSummaryFields } from "src/components/views/erp/sales/customerOrderLine/utils/customerOrderOrOfferSummaryFields.ts";

export type { CustomerOrderOrOfferSummaryField } from "src/components/views/erp/sales/customerOrderLine/utils/customerOrderOrOfferSummaryFields.ts";

export interface CustomerOrderOrOfferSummaryTextProps {
	objectType: "CUSTOMER_ORDER" | "CUSTOMER_OFFER";
	summary: CustomerOrderSummary | CustomerOfferSummary;
}

export const CustomerOrderOrOfferSummaryText = ({ objectType, summary }: CustomerOrderOrOfferSummaryTextProps) => {
	const fields = useCustomerOrderOrOfferSummaryFields(objectType, summary);

	return (
		<Box
			sx={{
				display: "flex",
				columnGap: 2,
				alignSelf: "center",
				flexWrap: "wrap",
				maxHeight: "none",
				flexDirection: {
					xs: "column",
					sm: "row",
				},
			}}
		>
			{fields.map((field, index) => (
				<Typography key={index}>
					<i>{field.label}</i>: {field.value}
				</Typography>
			))}
		</Box>
	);
};
